const nb = {
  "comingSoon": "Kommer snart",
  "soonSub": "Ny trolljakt",
  "follow": "Følg med for nyheter",
  "playNow": "Spill fjordløypa nå",
  "prev": "Forrige løype",
  "next": "Neste løype",
  "of": "av",
  "readMore": "Les om løypa",
  "otherTrails": "Flere løyper på vei",
  "partner": {
    "kicker": "For bedrifter og kommuner",
    "badge": "For bedrifter",
    "title": "Bli partner med Trollfossjakten.",
    "pitch": "Hoteller, kafeer, badstuer, skisentre og hele kommuner kan sette sine egne troll på kartet. Jakten leder familier og turister rett til døra di — hele året.",
    "points": [
      "Stedet ditt markert på trollkartet",
      "Gjester forhåndsbestiller og betaler med Vipps",
      "Lanseringspris: 50 % rabatt for de 50 første"
    ],
    "cta": "Bli partner",
    "cta2": "For bedrifter",
    "pin": "Din bedrift her",
    "stamp": "50 % rabatt"
  },
  "names": {
    "partner": "Bli partner",
    "fjord": "Fjordløypa",
    "stairs": "Midnattsoltrappa",
    "farm": "Ågård-trollene",
    "forest": "Skogstien",
    "sea": "Havtrollruta"
  },
  "slides": {
    "stairs": {
      "kicker": "Spansdalen · Lavangen",
      "title": "Midnattsoltrappa: 20 troll på 2117 trinn.",
      "pitch": "En tretrapp rett opp fjellsiden ved Spanstind / Ruŋgugáisá — 380 høydemeter med utsikt over Spansdalen og Lavangsfjorden. Tjue troll venter på trinnene, på utsiktsplattformen og ved Henrikkafossen.",
      "stats": [
        [
          "20",
          "troll"
        ],
        [
          "2117",
          "trinn"
        ],
        [
          "380",
          "høydemeter"
        ]
      ],
      "note": "Best i midnattssola i juni og juli."
    },
    "farm": {
      "kicker": "Lavangen · Troms",
      "title": "Ågård-trollene: 30 troll på den andre siden av dalen.",
      "pitch": "En helt ny veistrekning på motsatt side av dalen, forbi røde gårder, hesjer, sauebeite og fjæra. Gårdstroll med strikkeluer gjemmer seg bak gjerder og melkespann.",
      "stats": [
        [
          "30",
          "troll"
        ],
        [
          "1",
          "ny vei"
        ],
        [
          "4",
          "årstider"
        ]
      ],
      "note": "En helt ny vei — og en helt ny gjeng troll."
    },
    "forest": {
      "kicker": "Lavangen · Gratangen",
      "title": "Skogstien: 25 troll mellom bjørk og furu.",
      "pitch": "En smal sti gjennom mosegrodd bjørke- og furuskog, forbi myrer med myrull, sildrende bekker og små klopper. Mosetroll med sopphatter titter fram bak stammer og steiner.",
      "stats": [
        [
          "25",
          "troll"
        ],
        [
          "1",
          "skogssti"
        ],
        [
          "4",
          "årstider"
        ]
      ],
      "note": "Ta med kameraet — og litt sjokolade."
    },
    "sea": {
      "kicker": "Gratangen · Lavangen · Sjøvegan",
      "title": "Havtrollruta: fang Kraken og kjempeskilpadden.",
      "pitch": "En båtrute på fjorden fra Gratangen via Lavangen til Sjøvegan. Under overflaten venter sjøtroll og to 45 meter lange kjemper — Kraken og den eldgamle kjempeskilpadden med en hel holme på ryggen.",
      "stats": [
        [
          "15",
          "sjøtroll"
        ],
        [
          "45 m",
          "lange kjemper"
        ],
        [
          "3",
          "havner"
        ]
      ],
      "note": "Egen båtpakke for betalende gjester."
    }
  }
};

export default nb;
